const isProduction: boolean = process.env.NODE_ENV === 'production';
const isLocalhost: boolean =
  typeof window !== 'undefined' &&
  /^(localhost|127\.0\.0\.1)$/.test(window.location.hostname);
const useRemoteApiInDev: boolean = process.env.REACT_APP_USE_REMOTE_API_IN_DEV === 'true';

// In local development, default to '/api' so CRA's proxy can forward to the local backend.
// Remote API use in dev must be explicit to avoid CORS/preflight issues from localhost.
const API_BASE_URL: string = (!isProduction && isLocalhost && !useRemoteApiInDev)
  ? '/api'
  : (process.env.REACT_APP_API_URL || '/api');

console.log('Environment:', process.env.NODE_ENV);
console.log('isProduction:', isProduction);
console.log('isLocalhost:', isLocalhost);
console.log('useRemoteApiInDev:', useRemoteApiInDev);
console.log('API_BASE_URL:', API_BASE_URL);

export const API_ENDPOINT: string = API_BASE_URL;

/**
 * Returns the URL to use for displaying a user's profile photo in the UI.
 * Route all persisted user photos through our backend display endpoint so the
 * UI uses one stable path whether the stored URL is Google-hosted or elsewhere.
 */
export function getProfilePhotoDisplayUrl(
  userId: number | null | undefined,
  profilePhotoUrl: string | null | undefined
): string | null | undefined {
  if (!profilePhotoUrl) return profilePhotoUrl;
  if (!userId) return profilePhotoUrl;
  return `${API_ENDPOINT}/users/${userId}/profile-photo`;
}

export interface BroadcasterConfig {
  BASE_URL: string;
  CORS_HEADERS: { [key: string]: string };
  BROADCAST_HEADERS: { [key: string]: string };
  fetchConfig: { credentials: RequestCredentials; mode: RequestMode };
}

const BROADCASTER_CONFIG: BroadcasterConfig = {
  BASE_URL: 'https://www.buskplayer.com',
  CORS_HEADERS: {
    'Access-Control-Allow-Origin': 'http://localhost:3000',
    'Access-Control-Allow-Methods': 'GET, PUT, POST, OPTIONS',
    'Access-Control-Allow-Headers': 'Authorization, Content-Type, Ice-Name, Ice-Description, Ice-Public, Ice-Audio-Info, Origin',
    'Access-Control-Allow-Credentials': 'true',
    'Access-Control-Max-Age': '86400'
  },
  BROADCAST_HEADERS: {
    'Authorization': 'Basic ' + btoa('source:EtherIsBetter'),
    'Content-Type': 'audio/webm;codecs=opus',
    'Ice-Name': 'Web Broadcaster',
    'Ice-Description': 'Integrated broadcaster streams (Ether)',
    'Ice-Public': '1',
    'Ice-Audio-Info': 'ice-samplerate=44100;ice-bitrate=128;ice-channels=2'
  },
  fetchConfig: {
    credentials: 'include',
    mode: 'cors'
  }
};

export default BROADCASTER_CONFIG;
  
